import { supabase } from "~/integrations/supabase/client";

export interface KardexFilters {
  dateFrom?: string;
  dateTo?: string;
  warehouseCode?: string;
  productId?: string;
  movementType?: string;
  userId?: string;
  search?: string;
}

export interface KardexRow {
  bodega: string;
  fecha: string;
  codigo: string;
  item: string;
  um: string;
  transaccion: string;
  docto: string;
  folio: string | null;
  origen_destino: string | null;
  entrada: number;
  salida: number;
  // null for plant<->plant (fg_plant_transfers) rows: the un-ingested plant pool has no
  // reliable running balance, so those rows show the movement without a saldo corrido.
  saldo: number | null;
  usuario: string | null;
}

export const kardexService = {
  /**
   * Fetch the WMS Kardex (stock ledger with running balance).
   * `fecha` is a Chile-local calendar date ("YYYY-MM-DD"). Each row's `saldo`
   * is its own (bodega, producto) running balance, computed server-side, so the
   * client may re-sort rows freely — every saldo value stays correct on its row.
   */
  async getKardex(filters: KardexFilters): Promise<KardexRow[]> {
    const { data, error } = await supabase.rpc("get_wms_kardex" as never, {
      p_date_from: filters.dateFrom ?? null,
      p_date_to: filters.dateTo ?? null,
      p_warehouse_code: filters.warehouseCode ?? null,
      p_product_id: filters.productId ?? null,
      p_movement_type: filters.movementType ?? null,
      p_user_id: filters.userId ?? null,
      p_search: filters.search ?? null,
    });

    if (error) throw error;

    return (data ?? []) as unknown as KardexRow[];
  },
};
